export default __webpack_public_path__ + "images/48398a9d7825262adc3f0bc10aee33b4.svg";